import { Navigate, Route, Routes } from 'react-router-dom';

import { ConnectedDevicesBusylightView } from './views/busylight/connectedDevicesBusylight.view';
import { ConnectedDevicesJabraView } from './views/jabra/connectedDevicesJabra.view';

type Props = {
  hasJabraAccess: boolean;
};
export const PreferencesConnectedDevicesRoutes = ({
  hasJabraAccess,
}: Props) => (
  <Routes>
    <Route index element={<Navigate to="busylight" replace />} />
    <Route path="busylight" element={<ConnectedDevicesBusylightView />} />
    {hasJabraAccess && (
      <Route path="jabra" element={<ConnectedDevicesJabraView />} />
    )}
  </Routes>
);
